import React, { useState } from "react";
import StatelessTable from "../../../../common/components/elements/StatelessTable";
import I18n from "i18n-js";
import Dropdown from "../../../../common/components/elements/Dropdown";
import { arrayOf, shape } from "prop-types";
import InterventionType from "../../../../intervention/models/InterventionType";
import Purpose from "../../../../intervention/models/Purpose";
import { ROUTE_INTERVENTIONS } from "../../../../../routes";
import { Link } from "react-router-dom";

InstallationInterventionList.propTypes = {
  installation: shape().isRequired,
  interventions: arrayOf(shape()).isRequired,
};

export default function InstallationInterventionList({ installation, interventions }) {
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <div>
      <div className="d-flex flex-column align-items-end mb-2">
        <Link
          className="btn btn-primary"
          to={`${ROUTE_INTERVENTIONS}?installation=${installation.uuid}`}
        >
          {I18n.t("pages.installations.view.interventions.detailled-list:label")}
        </Link>
      </div>
      <StatelessTable
        className=""
        data={interventions}
        pagination={interventions?.length > 5 ? true : false}
        perPage={5}
        currentPage={currentPage}
        onPageChanged={(newPage) => {
          setCurrentPage(newPage);
        }}
        headData={[
          I18n.t("pages.installations.view.interventions.type:label"),
          I18n.t("pages.installations.view.interventions.purpose:label"),
          I18n.t("pages.installations.view.interventions.creation:label"),
          I18n.t("pages.installations.view.interventions.documents:label"),
        ]}
        rowData={({ type, purpose, creation, documents }) => {
          const documentElements = documents?.map((document, index) => {
            return (
              <a href={document.url} target="blank" key={index}>
                {I18n.t(`pages.interventions.list.document.${document["type"]}`)}
              </a>
            );
          });
          return [
            I18n.t(InterventionType.readableFor(type)),
            purpose ? I18n.t(Purpose.readableFor(purpose)) : null,
            creation,
            documents && (
              <Dropdown
                label={
                  documentElements.length +
                  " " +
                  I18n.t("pages.interventions.list.head.document")
                }
              >
                {documentElements}
              </Dropdown>
            ),
          ];
        }}
      />
    </div>
  );
}
